import _ from 'lodash';
function flattenVNodes(vnodes) {
    const result = [];
    function traverse(vnodes) {
        vnodes.forEach((vnode) => {
            result.push(vnode);
            if (vnode.componentInstance) {
                traverse(vnode.componentInstance.$children.map((item) => item.$vnode));
            }
            if (vnode.children) {
                traverse(vnode.children);
            }
        });
    }
    traverse(vnodes);
    return result;
}
// 根据虚拟节点的顺序对字节点对象引用进行排序
export function sortChildren(children, parent) {
    const { componentOptions } = parent.$vnode;
    if (!componentOptions || !componentOptions.children) {
        return;
    }
    const vnodes = flattenVNodes(componentOptions.children);
    children.sort((a, b) => {
        return vnodes.indexOf(a.$vnode) - vnodes.indexOf(b.$vnode);
    });
}
// 判断属性是否定义
export const isDefined = (object, propName) => {
    return typeof object[propName] !== 'undefined' && object[propName] !== null;
};
// 转换vw尺寸单位
export const genVWUnit = (size) => {
    return `${(size / 375) * 100}vw`;
};
// 统一返回Animate.css类名
export const getAnimateEffect = (animation) => {
    return `animate__animated animate__faster animate__${animation}`;
};
export function isObject(val) {
    return _.isObject(val);
}
// 过滤所有的空字符
export const trimAll = (value) => {
    if (typeof value === 'string') {
        return value.replace(/\s/g, '');
    }
    return value;
};
export const env = () => {
    let env = 'fat';
    const { pathname } = window.location;
    if (pathname.indexOf('fat') > -1) {
        env = 'fat';
    }
    else if (pathname.indexOf('uat') > -1) {
        env = 'uat';
    }
    else if (pathname.indexOf('pre') > -1) {
        env = 'pre';
    }
    else {
        env = 'pro';
    }
    return env;
};
export default {
    sortChildren,
    isDefined,
    genVWUnit,
    getAnimateEffect,
    isObject,
    trimAll,
    env
};
//# sourceMappingURL=index.js.map